var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.kk==1)?_c('div',[_c('StaffManage')],1):_vm._e(),(_vm.kk==2)?_c('div',[_c('StaffAdd')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }